<template>
  <Cards>
    <div>
      <TopSearch :adminShow="false" :search-show="true" @searchKey="getSearchKey"/>
    </div>
  </Cards>
  <Cards>
    <div>
      <div class="top_tips">
        <h2 style="font-weight: 500;font-size: 16px !important;">{{ $t('common.customer.followup.list') }}</h2>
        <div>
          <el-button type="primary" size="small" :loading="followIsLoading||isBuildDB" :icon="Finished"
                     @click="handleClickFollow">
            {{
              $t("common.followup")
            }}
          </el-button>
          <el-button type="primary" size="small" :icon="Timer" @click="delayDayAll">{{
              $t("common.bulk.delay")
            }}
          </el-button>
          <el-button size="small" :icon="CircleClose" @click="cancelAll">{{
              $t("common.bulk.cancel")
            }}
          </el-button>
        </div>
      </div>
      <el-table
          v-loading="isLoading"
          id="sp_tables"
          ref="multipleTableRef"
          :data="tableData"
          style="width: 100%; margin-top: 10px;"
          @selection-change="handleSelectionChange"
          @select="handleCheck"
          @select-all="handleClickSelectAll"
          :cell-style="rowClassName"
          :header-cell-style="headerClassName"
          :row-key="row => row.id"
          @cell-mouse-leave="clearVisiblePopover"
      >
        <el-table-column type="selection" width="40" :selectable="checkSelectable" :reserve-selection="true"/>
        <el-table-column
            v-for="item in table_columns_follow"
            :key="item.key"
            :label="item.key"
            :prop="item.value"
            :width="handleClickSelectWidth(item)"
            :min-width="handleClickSelectMinWidth(item)"
        >
          <!--          :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
          <template #default="{row}">
            <template v-if="item.value==='customerCode'">
              <div :ref="ref => (refMap[`${row.id}_code`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_code`], row, 7)"
                   v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                   class="over_normal"
                   :key="row.customerCode">
                {{
                  getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.customerCode }}
              </div>
            </template>
            <template v-else-if="item.value === 'customerName'">
              <div :ref="el => setRef(el, row)"
                   class="over_text"
                   :key="row.customerName"
                   @mouseenter="handleMouseEnter(row)"
                   @click.native.stop="toDetail(row)">
                {{ row.customerName }}
              </div>
            </template>
            <template v-else-if="item.value==='customerOrigin'">
              <div :ref="ref => (refMap[`${row.id}_source`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"
                   v-if="getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                   class="over_normal"
                   :key="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name">
                <el-tag type="info" v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                  {{
                    getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                        ? formatText(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                        : row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name
                  }}
                </el-tag>
                <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                  +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '').length - 1 }}
                </template>
              </div>
              <div v-else class="over_normal">
                <el-tag type="info"
                        v-if="row?.mailCustomerOriginDetailVoList&&row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                  {{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name }}
                </el-tag>
                <template v-else></template>
                <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                  +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== "").length - 1 }}
                </template>
              </div>
            </template>
            <template v-else-if="item.value==='customerIntention'">
              <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
              <div :ref="ref => (refMap[`${row.id}_product`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 9)"
                   v-if="getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                   class="over_normal"
                   :key="row?.mailProductDetailVoList?.filter(it => it.name!=='')[0]?.name">
                <el-tag type="info" v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length!==0">
                  {{
                    getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                        ? formatText(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                        : row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name
                  }}
                </el-tag>
                <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length>1">
                  +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                </template>
              </div>
              <div v-else class="over_normal">
                <el-tag type="info"
                        v-if="row?.mailProductDetailVoList&&row?.mailProductDetailVoList?.filter(it => it.name!=='').length!==0">
                  {{ row?.mailProductDetailVoList?.filter(it => it.name !== "")[0]?.name }}
                </el-tag>
                <template v-else></template>
                <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !== '').length>1">
                  +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                </template>
              </div>
            </template>
            <template v-else-if="item.value ==='zoneAddress'">
              <div style="cursor: pointer;">
                <!-- 触发内容1 -->
                <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                          @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                          v-if="row.zoneAddress"
                          :src="flag[row.zoneCode]"
                          style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                          lazy
                />
              </div>
            </template>
            <template v-else-if="item.value === 'customerType'">
              <div :ref="ref => (refMap[`${row.id}_type`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_type`], row, 4)"
                   v-if="getTextLength(row.customerType) > sizeMaxNumber"
                   :key="row.customerType"
                   class="over_normal">
                {{
                  getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.customerType }}
              </div>
            </template>
            <template v-else-if="item.value === 'customerLevel'">
              <el-button size="small" link type="primary" style="width: 100%; padding: 0;">
                {{ row.customerLevel }}
              </el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.cz')" :width="lang==='en'?210:170">
          <template #default="{ row, column, $index }">
            <el-button size="small" type="primary" @click="follow(row, column, $index)" link
            >{{ $t('common.followup') }}
            </el-button
            >
            <el-button size="small" type="primary" @click="delay(row, column, $index)" link
            >{{ $t('common.delay') }}
            </el-button
            >
            <ConfirmDeletePopover
                :visible="row.popoverVisibleCancel"
                :width="164"
                :message="$t('sys.message.ask.followup.cancel')"
                @update:visible="(value) => (row.popoverVisibleCancel = value)"
                @confirm:delete="handleCancel(row, column, $index)"
            >
              <template #settings>
                <el-button
                    type="warning"
                    size="small"
                    @click="cancel(row, column, $index)"
                    link
                >{{ $t('common.cancel') }}
                </el-button
                >
              </template>
            </ConfirmDeletePopover
            >
          </template>
        </el-table-column>
        <template #empty>
          <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
        </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <Pagination v-model:modelValue="currentFlow"
                  v-model:pageSizeValue="sizeFLow"
                  :total="totalsFlow"
                  v-if="totalsFlow"
                  ref="PageZQ"
                  @change="handleCurrentChange"
                  @checkAllItemPage="checkAllItemPage"
                  @unCheckAllItemPage="unCheckAllItemPage"
                  @getSelect="getSelectValue"
                  :multipleSelection="multipleSelection"
                  :is-show-select="true"
      ></Pagination>
    </div>
  </Cards>

  <Dialog
      v-model="dialogVisible"
      :title="$t('common.yst')"
      :dialogVisible="dialogVisible"
      :isHeadLine="false"
      :width="'400'"
      @update:dialogVisible="(val) => (dialogVisible = val)"
  >
    <template #content>
      <el-date-picker
          size="small"
          style="width: 200px;margin: auto;display: flex;margin-top: 10px"
          v-model="delayDay"
          type="date"
          :placeholder="$t('common.slt')"
          :disabled-date="disabledDate"
      />
    </template>
    <template #footer>
      <div class="buttons_bottom">
        <el-button size="small" @click="dialogVisible = false">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="addDelayDay" :loading="isLoadingDelay">{{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <Dialog
      v-model="cancelAllVisible"
      :dialogVisible="cancelAllVisible"
      :isHeadLine="false"
      :title="$t('sys.team.info')"
      :width="'420'"
      @update:dialogVisible="(val) => (cancelAllVisible = val)"
      align-center
  >
    <template #content>
      <div class="content_box">
        <div class="inner_text">{{ $t('common.sl1') }}</div>
      </div>
    </template>
    <template #footer>
      <div class="buttons_bottom">
        <el-button size="small" @click="cancelAllVisible = false">{{ $t('common.sss16') }}</el-button>
        <el-button style="margin-left: 0px !important;" size="small" type="primary" @click="handleCancelAll"
                   :loading="isLoadingCancel">
          {{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <!--  el-popover-->
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      trigger="hover"
      :show-after="1200"
      effect="dark"
      placement="right"
  >
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content"
           v-html="
                          '<div>' +
                          activeItemElpopover.maiContactVOList
                            .map((item) => {
                              return `${item.contactName}<br/>`;
                            })
                            .join('') +
                          '</div>'
                        "
      ></div>
    </template>
    <template v-else-if="popoverType === 2">
      <!-- 业务逻辑2 -->
      <div class="popover-content"
           v-html="
                '<div>' +
                activeItemElpopover.mangerVOList
                  .map((item) => {
                    return `${item.managerName}<br/>`;
                  })
                  .join('') +
                '</div>'
              "
      ></div>
    </template>
    <template v-else-if="popoverType===3">
      <!-- 业务逻辑3 -->
      <div class="popover-content">
        {{ activeItemElpopover.zoneAddress }}
      </div>
    </template>
    <template v-else-if="popoverType===4">
      <div class="popover-content">
        {{ activeItemElpopover.customerType }}
      </div>
    </template>
    <template v-else-if="popoverType===5">
      <div class="popover-content">
        {{ activeItemElpopover.customerName }}
      </div>
    </template>
    <template v-else-if="popoverType===6">
      <div class="popover-content">
        {{ activeItemElpopover.customerOrigin }}
      </div>
    </template>
    <template v-else-if="popoverType===7">
      <div class="popover-content">
        {{ activeItemElpopover.customerCode }}
      </div>
    </template>
    <template v-else-if="popoverType === 9">
      <div class="popover-content">
        {{ activeItemElpopover?.mailProductDetailVoList?.filter(it => it.name !== '')[0].name }}
      </div>
    </template>
  </el-popover>
</template>
<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {dayjs, ElMessage, ElTable} from "element-plus";

import Cards from "./Cards.vue";
import TopSearch from "./TopComponents/TopSearch.vue";
import Dialog from "@/components/Dialog.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";

import {getMailCustomerFollow, batchDelayCancel} from "@/api/customer.js";
import {useStore} from "vuex";
import {table_columns_follow} from "@/views/Customer/map";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import flag from "@/assets/flag";
import {flexWidth} from "@/utils/tableWidth";
import {i18n} from "@/lang"
import {debouncePlus, isEmpty} from "@/utils/mylodash";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import {CircleClose, Finished, Timer} from "@element-plus/icons-vue";
import {Storage} from "@/utils/storage"
import {CustomerTable} from "@/views/Marketing/db_customer";
import sessionStore from "@/utils/sessionStore";

const store = useStore()
const router = useRouter();
const teamId = computed(() => store.state.email.teamID);
// 语言
const lang = computed(() => store.state.system.langLocal)
// 延迟时间
const delayDay = ref("");

// table 的ref 对象
const multipleTableRef = ref();
// 表格是否加载
const isLoading = ref(false)
// 批量选中的客户
const multipleSelection = computed(() => store.state.customer.multipleSelection)


const disabledDate = (time) => {
  return time.getTime() < Date.now();
};

// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))
const getSearchKey = async (value) => {
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  searchValue.value = newObj;
  console.log(searchValue.value, "ffff");
  // 列表数据
  await getListFollow();
  isSelectAll.value ? multipleTableRef.value?.toggleAllSelection() : multipleTableRef.value?.clearSelection()
  await resetInit()
};

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const isApplyingShiftSelection = ref(false)
const shiftAnchorIndex = ref(null)
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};
const handleSelectionChange = async (val) => {
  console.log(val, '====')
  if (isApplyingShiftSelection.value) return
  await store.commit("customer/setMultipleSelection", val)
};

// 分页
const currentFlow = ref(1);
const sizeFLow = ref(10);
const totalsFlow = ref(0);
const isSelectAll = ref(false);

async function handleCurrentChange(page) {
  const {pageNo, pageSize} = page
  currentFlow.value = pageNo;
  sizeFLow.value = pageSize;
  //  重新获取数据
  await getListFollow();
  // 全选
  if (isSelectAll.value) {
    await getSelectValue()
  }
}

const handleCheck = async (selection, row) => {
  if (isSelectAll.value) {
    isSelectAll.value = false;
  }
  if (!row) {
    await getSelectChange(selection)
    return
  }

  const clickedIndex = tableData.value.findIndex(item => item.id === row.id)
  const isRowSelectedNow = Array.isArray(selection) && selection.some(item => item.id === row.id)

  if (!isShiftPressed.value || shiftAnchorIndex.value === null || shiftAnchorIndex.value === -1 || clickedIndex === -1) {
    shiftAnchorIndex.value = clickedIndex
    await getSelectChange(selection)
    return
  }

  const start = Math.min(shiftAnchorIndex.value, clickedIndex)
  const end = Math.max(shiftAnchorIndex.value, clickedIndex)
  isApplyingShiftSelection.value = true
  try {
    for (let i = start; i <= end; i++) {
      const r = tableData.value[i]
      if (r) {
        multipleTableRef.value?.toggleRowSelection(r, isRowSelectedNow)
      }
    }
    await nextTick(async () => {
      await store.commit("customer/setMultipleSelection", multipleTableRef.value?.getSelectionRows?.() ?? selection)
      await getSelectChange(multipleTableRef.value?.getSelectionRows?.() ?? selection)
    })
  } finally {
    await nextTick(() => {
      isApplyingShiftSelection.value = false
    })
  }
}

const checkAllItemPage = () => {
  multipleTableRef.value.clearSelection()
  isSelectAll.value = true
}
const unCheckAllItemPage = () => {
  multipleTableRef.value.clearSelection()
  isSelectAll.value = false
}
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  if (isSelectAll.value) {
    await getListFollowAll()
  }
  console.log(isSelectAll.value, 'isSelectAll.value')
  await nextTick(() => {
    tableData.value.forEach((item) => {
      multipleTableRef?.value.toggleRowSelection(item, isSelectAll.value)
    })
  })
}

// 客户跟进表数据
const tableData = ref([]);
const getListFollow = async () => {
  isLoading.value = true;
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  let res = await getMailCustomerFollow({
    ...searchValue.value,
    pageSize: sizeFLow.value,
    pageNo: currentFlow.value,
    teamId: teamId.value
  });
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  isLoading.value = false;
  const {records, total, current, size} = res.result;
  tableData.value = records;
  sizeFLow.value = size;
  totalsFlow.value = total;
  currentFlow.value = current;
};


const isBuildDB = ref(false)
const getListFollowAll = async () => {
  isBuildDB.value = true
  let res = await getMailCustomerFollow({
    ...searchValue.value,
    teamId: teamId.value,
    isSelectAll: 0,
  });
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  console.log(res.result, 'resdddd')
  const arrayList = res.result.map(item => ({id: item.id, customerId: item.customerId}))
  await CustomerTable.bulkAdd(arrayList)
  isBuildDB.value = false
  // 缓存所有的客户跟进邮箱
  // Storage.set("STEP_FOLLOW_CUSTOMER", res.result)
}

// 跟进
const isFllow = ref(false)
const follow = async (row) => {
  isFllow.value = true
  localStorage.setItem('follow', JSON.stringify(row))
  const query = {type: "follow"};
  if (row.customerId) {
    query.customerId = row.customerId;
  }
  const url = row.customerId ? `/email/write_mail?type=follow&customerId=${row.customerId}` : `/email/write_mail?type=follow`
  const newUrl = router.resolve(url)
  openNewWindow(newUrl.href)
  // 重新获取列表数据
  await getListFollow();
  await resetInit()
  // //   取消目标 邮件跟进
  let timer = setTimeout(() => {
    handleCancel(row)
    clearTimeout(timer)
  }, 300)
};
const openNewWindow = (url) => {
  window.open(url, "_blank");
};

// 客户批量跟进
const followIsLoading = ref(false)
const handleClickFollow = async () => {
  // 选中的结果需要缓存
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  //
  // const mailCustomerList = multipleSelection.value.map(item => ({customerId: item.customerId}))
  // await CustomerTable.clear()
  // await CustomerTable.bulkAdd(mailCustomerList)
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const followSearch = encodeURIComponent(JSON.stringify(searchValue.value ?? {}))
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: 3, step: 0, isOpen: 1, followSearch}
  })
  window.open(routeUrl.href, '_target')
  isFllow.value = false
  await resetInit()
}


// 延迟对话框
const dialogVisible = ref(false);

// 延迟
const activeItem = ref(null);
const delay = async (row, column, $index) => {
  dialogVisible.value = true;
  activeItem.value = row;
};

// 批量延迟
const delayDayAll = () => {
  console.log(isEmpty(multipleSelection.value), 'multipleSelection')
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  dialogVisible.value = true;
};

// 确认添加延迟时间
const isLoadingDelay = ref(false)
const addDelayDay = async () => {
  if (delayDay.value === "") {
    ElMessage.warning(i18n.global.t('please.enter.time'));
    return;
  }
  // 确认添加
  let targetObj = {
    mailCustomerFollowListDTOList: [],
    teamId: teamId.value,
    time: dayjs(delayDay.value).format("YYYY-MM-DD HH:mm:ss"),
    type: 1,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  if (multipleSelection.value.length >= 1) {
    // 批量
    let result = multipleSelection.value.map((item) => {
      return {
        customerId: item.customerId,
        customerTypeId: item.customerTypeId,
        id: item.id,
      };
    });
    targetObj.mailCustomerFollowListDTOList = [...result];
    console.log("all", targetObj);
  } else {
    // 单个
    const {customerId, customerTypeId, id} = activeItem.value;
    targetObj.mailCustomerFollowListDTOList = [
      {customerId, customerTypeId, id},
    ];

    console.log("dan", targetObj);
  }
  if (isSelectAll.value) {
    delete targetObj.mailCustomerFollowListDTOList
  }
  console.log(targetObj, "批量取消");
  isLoadingDelay.value = true
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    isLoadingDelay.value = false
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  isLoadingDelay.value = false
  dialogVisible.value = false;
  delayDay.value = "";
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
};


// 取消对话框
const popoverVisibleCancel = ref(false);
// 取消
const cancel = async (row, colum, $index) => {
  row.popoverVisibleCancel = true;
};
// 确认取消
const handleCancel = async (row) => {
  const {customerId, customerTypeId, id, alertDay} = row;
  let targetObj = {
    mailCustomerFollowListDTOList: [{id,}],
    teamId: teamId.value,
    type: 2,
  };
  console.log(targetObj, "targetObj");
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  if (!isFllow.value) {
    ElMessage.success(res.message);
  }
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  isFllow.value = false
  await resetInit()
};

// 批量取消对话框
const cancelAllVisible = ref(false);
// 批量取消
const cancelAll = () => {
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  cancelAllVisible.value = true;
};
// 确定批量取消
const isLoadingCancel = ref(false)
const handleCancelAll = async () => {
  const result = multipleSelection.value
  console.log(result)
  const targetList = result.map((item) => {
    return {
      customerId: item.customerId,
      customerTypeId: item.customerTypeId,
      id: item.id,
      alertDay: item.alertDay,
    };
  });
  const targetObj = {
    mailCustomerFollowListDTOList: [...targetList],
    teamId: teamId.value,
    type: 2,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  if (isSelectAll.value) {
    delete targetObj.mailCustomerFollowListDTOList
  }
  console.log(targetObj, '批量延迟')
  isLoadingCancel.value = true
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    isLoadingCancel.value = false
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  isLoadingCancel.value = false
  cancelAllVisible.value = false;
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
};

onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
  // await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

watch(() => teamId.value, async () => {
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
})

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const toDetail = (row) => {
  const newUrl = router.resolve('/email/customer/detail/' + row.customerId + '?type=1')
  openNewWindow(newUrl.href);
}

const checkSelectable = (row, index) => {
  return !isSelectAll.value;
}

// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const normalizeGlobalSelectedRows = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value
  }
  return {}
}


const getSelectChange = async (val) => {
  console.log(val, '当前页勾选的值');
  // 选择 底部选择 取消 全部勾选
  await nextTick(async () => {
    // 获取当前页的页码，假设分页数据存储在 store 中
    const currentPage = currentFlow.value;
    // 获取全局勾选记录
    const globalSelectedRows = normalizeGlobalSelectedRows(store.state.customer.globalSelectedRows);

    // 更新当前页的勾选数据到全局记录
    globalSelectedRows[currentPage] = val;

    // 提交更新全局勾选记录到 store
    await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

    // 合并所有页的勾选数据
    const allSelectedRows = Object.values(globalSelectedRows).flat();

    // 更新 `selectedRows` 和 `targetEmailList`
    await store.commit("customer/setSelectedRows", allSelectedRows);
    // await Storage.set("STEP_FOLLOW_CUSTOMER", allSelectedRows.map(item => item.customerId))
    await CustomerTable.clear()
    await CustomerTable.bulkAdd(allSelectedRows.map(item => ({id: item.id, customerId: item.customerId})))
  })
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码，假设分页数据存储在 store 中
  const currentPage = currentFlow.value;

  // 获取全局勾选记录
  const globalSelectedRows = normalizeGlobalSelectedRows(store.state.customer.globalSelectedRows);

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows[currentPage] = val;

  // 提交更新全局勾选记录到 store
  await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

  // 合并所有页的勾选数据
  const allSelectedRows = Object.values(globalSelectedRows).flat();

  // 更新 `selectedRows` 和 `targetEmailList`
  await store.commit("customer/setSelectedRows", allSelectedRows);
  // await Storage.set("STEP_FOLLOW_CUSTOMER", allSelectedRows.map(item => item.customerId))
  await CustomerTable.clear()
  await CustomerTable.bulkAdd(allSelectedRows.map(item => ({id: item.id, customerId: item.customerId})))
}

// 重置记录
const PageZQ = ref()
const resetInit = async () => {
  try {
    // parent
    isSelectAll.value = false
    // child
    await PageZQ.value.setIsSelectAll(isSelectAll.value)
    // 清空选项
    await store.commit("customer/setGlobalSelectedRows", {});
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setMultipleSelection", [])
    await multipleTableRef.value?.clearSelection()
  } catch (e) {
    console.log(e)
  }
}


const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isCounterElection = computed(() => store.state.customer.isCounterElection);
// 记录历史记录
const resetSelection = async () => {
  await nextTick();
  await nextTick(); // 双重保险，确保 DOM 和组件都挂载完成

  console.log(multipleTableRef?.value, tableData.value, selectedRows.value, 'treeTable?.value')

  if (!multipleTableRef?.value || !Array.isArray(selectedRows.value)) return;

  tableData.value.forEach((item) => {
    const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
    console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected');
    multipleTableRef?.value.toggleRowSelection(item, isSelected);
  });
};

// 当前页数据发生变化
watch(() => tableData.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})


const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}


// 设置 临界值 width
const middleValueWidth = ref(165)
// 字数大致限制
const sizeMaxNumber = ref(16)
const handleClickSelectWidth = (item) => {
  if (item.value === "customerCode") {
    return flexWidth('customerCode', tableData.value, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', tableData.value, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', tableData.value, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', tableData.value, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerOrigin') {
    return flexWidth('customerOrigin', tableData.value, i18n.global.t('common.customer.source')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerOrigin', tableData.value, i18n.global.t('common.customer.source')) + 65
  } else if (item.value === 'customerIntention') {
    return flexWidth('customerIntention', tableData.value, i18n.global.t('common.interest.product')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerIntention', tableData.value, i18n.global.t('common.interest.product')) + 65
  } else if (item.value === 'createName' || item.value === 'maiContactVOList' || item.value === 'zoneAddress' || item.value === 'auditName' || item.value === 'userName' || item.value === 'mangerVOList') {
    return 80;
  } else if (item.value === 'alertDay') {
    return lang.value !== "zh-CN" ? 150 : 80;
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 120 : 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else {
    return "auto"
  }
}
const handleClickSelectMinWidth = (item) => {
  if (item.value === "customerOrigin" || item.value === 'customerIntention') {
    return 140;
  } else if (item.value === 'alertDay') {
    return 180;
  } else {
    return 120;
  }
}


const overflowMap = reactive({})

const setRef = (el, row) => {
  if (!el) return
  refMap[row.id] = el

  nextTick(() => {
    overflowMap[row.id] = Math.ceil(el.scrollWidth) >= Math.ceil(el.clientWidth)
  })
}

const handleMouseEnter = (row) => {
  if (overflowMap[row.id]) {
    handleRef(refMap[row.id], row, 5)
  }
}

</script>

<style lang="less" scoped>
@import "../../less/page.less";
@import "./less/follow.less";

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
